<script setup>
</script>
<template>
  <div class="page-container holiday-page share-market-holiday">
    <div class="holiday-banner-section">
      <!-- banner-start -->
      <section class="holiday-banner container_fld">
        <section class="breadcrumbs-sec">
          <div class="container breadcrumbs-ol block">
            <div class="stocks-indices-breadcrumbs_wrap">
              <ol class="stocks-indices-breadcrumbs">

                <li>
                  <a href="/">
                    <span>Home </span>
                  </a>
                </li>
                <!-- <li>
                  <a href="/invest-in-share-market/">
                    <span>Invest </span>
                  </a>
                </li> -->
                <li>
                  <span>MCX Holidays 2025 </span>
                </li>
              </ol>
            </div>
          </div>
        </section>

        <div class="container coantainer_sec block">
          <div class="row">
            <div class="col-md-7 col-sm-7 pddg_col">
              <div class="banner_txt">
                <div data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="2000"
                  data-aos-offset="0">
                  <div class="banner-text">
                    <h1 class="header"> MCX Holidays 2025 </h1>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-md-5 pddg_col col-sm-5 desktop-content">

            </div>
          </div>
        </div>
      </section>
      <!-- banner-End -->
    </div>

    <section class="main-share-market-section">
      <div class="share-market-inner-section">
        <div class="main-heading">
          <p>Multi Commodity Exchange of India, or MCX, is the largest commodity exchange in the country. The exchange
            facilitates trading in a wide range of commodities and agri products. </p>
          <p>On weekdays MCX allows trading in two sessions— morning session from 9 am to 5 pm, and evening session from
            5:30 pm to 11:30 pm (up to 11:55 pm from November-March). MCX remains closed on all weekends and designated
            holidays. </p>
          <p>As per the MCX trading holidays list 2025, the exchange will remain open only in the morning session on the
            New Year Day on January 1.
          </p>
        </div>
        <div class="holidays-tabs" id="sticky-tab">
          <a href="/stocks-market/share-market-holidays/" class="tabs-items bg-transparent rounded-none">Trading Holidays</a>
          <a href="/stocks-market/nse-holidays/" class="tabs-items bg-transparent rounded-none">NSE Holidays</a>
          <a href="/stocks-market/bse-holidays/" class="tabs-items bg-transparent rounded-none">BSE Holidays</a>
          <a href="/stocks-market/mcx-holidays/" class="tabs-items bg-transparent rounded-none active">MCX Holidays</a>
        </div>


        <section class="holidays">
          <div class="container home-container">
            <div class="a-article-wrapper holidays-wrapper">
              <h2><strong>MCX Holidays falling on weekdays and weekends in 2025</strong></h2>
              <div class="table-responsive">
                <table>
                  <thead>
                    <tr>
                      <th>MCX Holiday List</th>
                      <th>Date</th>
                      <th>Day</th>
                      <th>Morning Session</th>
                      <th>Evening Session</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>New Year Day</td>
                      <td>January 01, 2025</td>
                      <td>Wednesday</td>
                      <td>Open</td>
                      <td>Closed</td>
                    </tr>
                    <tr>
                      <td>Republic Day</td>
                      <td>January 26, 2025</td>
                      <td>Sunday</td>
                      <td>Closed</td>
                      <td>Closed</td>
                    </tr>
                    <tr>
                      <td>Maha Shivratri</td>
                      <td>February 26, 2025</td>
                      <td>Wednesday</td>
                      <td>Closed</td>
                      <td>Open</td>
                    </tr>
                    <tr>
                      <td>Holi</td>
                      <td>March 14, 2025</td>
                      <td>Friday</td>
                      <td>Closed</td>
                      <td>Open</td>
                    </tr>
                    <tr>
                      <td>Id-ul-Fitr (Ramzan ID)</td>
                      <td>March 31, 2025</td>
                      <td>Monday</td>
                      <td>Closed</td>
                      <td>Open</td>
                    </tr>
                    <tr>
                      <td>Ram Navami</td>
                      <td>April 06, 2025</td>
                      <td>Sunday</td>
                      <td>Closed</td>
                      <td>Closed</td>
                    </tr>
                    <tr>
                      <td>Mahavir Jayanti</td>
                      <td>April 10, 2025</td>
                      <td>Thursday</td>
                      <td>Closed</td>
                      <td>Open</td>
                    </tr>
                    <tr>
                      <td>Dr. Baba Saheb Ambedkar Jayanti</td>
                      <td>April 14, 2025</td>
                      <td>Monday</td>
                      <td>Closed</td>
                      <td>Open</td>
                    </tr>
                    <tr>
                      <td>Good Friday</td>
                      <td>April 18, 2025</td>
                      <td>Friday</td>
                      <td>Closed</td>
                      <td>Closed</td>
                    </tr>
                    <tr>
                      <td>Maharashtra Day</td>
                      <td>May 01, 2025</td>
                      <td>Thursday</td>
                      <td>Closed</td>
                      <td>Open</td>
                    </tr>
                    <tr>
                      <td>Bakri Eid</td>
                      <td>June 07, 2025</td>
                      <td>Saturday</td>
                      <td>Closed</td>
                      <td>Closed</td>
                    </tr>
                    <tr>
                      <td>Muharram</td>
                      <td>July 06, 2025</td>
                      <td>Sunday</td>
                      <td>Closed</td>
                      <td>Closed</td>
                    </tr>
                    <tr>
                      <td>Independence Day</td>
                      <td>August 15, 2025</td>
                      <td>Friday</td>
                      <td>Closed</td>
                      <td>Closed</td>
                    </tr>
                    <tr>
                      <td>Ganesh Chaturthi</td>
                      <td>August 27, 2025</td>
                      <td>Wednesday</td>
                      <td>Closed</td>
                      <td>Open</td>
                    </tr>
                    <tr>
                      <td>Dussehra/Gandhi Jayanti</td>
                      <td>October 02, 2025</td>
                      <td>Thursday</td>
                      <td>Closed</td>
                      <td>Closed</td>
                    </tr>
                    <tr>
                      <td>Diwali-Laxmi Pujan</td>
                      <td>October 21, 2025</td>
                      <td>Tuesday</td>
                      <td>Closed</td>
                      <td>Closed</td>
                    </tr>
                    <tr>
                      <td>Diwali-Balipratipada</td>
                      <td>October 22, 2025</td>
                      <td>Wednesday</td>
                      <td>Closed</td>
                      <td>Open</td>
                    </tr>
                    <tr>
                      <td>Guru Nanak Jayanti</td>
                      <td>November 05, 2025</td>
                      <td>Wednesday</td>
                      <td>Closed</td>
                      <td>Open</td>
                    </tr>
                    <tr>
                      <td>Christmas</td>
                      <td>December 25, 2025</td>
                      <td>Thursday</td>
                      <td>Closed</td>
                      <td>Closed</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p><a
                  href="https://www.mcxindia.com/docs/default-source/circulars/english/2024/december/circular-814-2024.pdf?sfvrsn=80f3539e_2"
                  target="_blank">MCX 2025 Trading Holiday Circular</a></p>
              <h2>
                <strong>MCX Holidays falling on weekdays in 2025</strong>
              </h2>
              <div class="table-responsive">
                <table>
                  <thead>
                    <tr>
                      <th>MCX Holiday List</th>
                      <th>Date</th>
                      <th>Day</th>
                      <th>Morning Session</th>
                      <th>Evening Session</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>New Year Day</td>
                      <td>January 1, 2025</td>
                      <td>Wednesday</td>
                      <td>Open</td>
                      <td>Closed</td>
                    </tr>
                    <tr>
                      <td>Maha Shivratri</td>
                      <td>February 26, 2025</td>
                      <td>Wednesday</td>
                      <td>Closed</td>
                      <td>Open</td>
                    </tr>
                    <tr>
                      <td>Holi</td>
                      <td>March 14, 2025</td>
                      <td>Friday</td>
                      <td>Closed</td>
                      <td>Open</td>
                    </tr>
                    <tr>
                      <td>Id-ul-Fitr (Ramzan ID)</td>
                      <td>March 31, 2025</td>
                      <td>Monday</td>
                      <td>Closed</td>
                      <td>Open</td>
                    </tr>
                    <tr>
                      <td>Mahavir Jayanti</td>
                      <td>April 10, 2025</td>
                      <td>Thursday</td>
                      <td>Closed</td>
                      <td>Open</td>
                    </tr>
                    <tr>
                      <td>Dr. Baba Saheb Ambedkar Jayanti</td>
                      <td>April 14, 2025</td>
                      <td>Monday</td>
                      <td>Closed</td>
                      <td>Open</td>
                    </tr>
                    <tr>
                      <td>Good Friday</td>
                      <td>April 18, 2025</td>
                      <td>Friday</td>
                      <td>Closed</td>
                      <td>Closed</td>
                    </tr>
                    <tr>
                      <td>Maharashtra Day</td>
                      <td>May 1, 2025</td>
                      <td>Thursday</td>
                      <td>Closed</td>
                      <td>Open</td>
                    </tr>
                    <tr>
                      <td>Independence Day</td>
                      <td>August 15, 2025</td>
                      <td>Friday</td>
                      <td>Closed</td>
                      <td>Closed</td>
                    </tr>
                    <tr>
                      <td>Ganesh Chaturthi</td>
                      <td>August 27, 2025</td>
                      <td>Wednesday</td>
                      <td>Closed</td>
                      <td>Open</td>
                    </tr>
                    <tr>
                      <td>Dussehra/Gandhi Jayanti</td>
                      <td>October 2, 2025</td>
                      <td>Thursday</td>
                      <td>Closed</td>
                      <td>Closed</td>
                    </tr>
                    <tr>
                      <td>Diwali-Laxmi Pujan</td>
                      <td>October 21, 2025</td>
                      <td>Tuesday</td>
                      <td>Closed</td>
                      <td>Closed</td>
                    </tr>
                    <tr>
                      <td>Diwali-Balipratipada</td>
                      <td>October 22, 2025</td>
                      <td>Wednesday</td>
                      <td>Closed</td>
                      <td>Open</td>
                    </tr>
                    <tr>
                      <td>Guru Nanak Jayanti</td>
                      <td>November 5, 2025</td>
                      <td>Wednesday</td>
                      <td>Closed</td>
                      <td>Open</td>
                    </tr>
                    <tr>
                      <td>Christmas</td>
                      <td>December 25, 2025</td>
                      <td>Thursday</td>
                      <td>Closed</td>
                      <td>Closed</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <h2><b>MCX Holidays falling on weekends </b></h2>
              <div class="table-responsive">
                <table>
                  <thead>
                    <tr>
                      <th>MCX Holidays on Weekends</th>
                      <th>Date</th>
                      <th>Day</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Republic Day</td>
                      <td>January 26, 2025</td>
                      <td>Sunday</td>
                    </tr>
                    <tr>
                      <td>Ram Navami</td>
                      <td>April 6, 2025</td>
                      <td>Sunday</td>
                    </tr>
                    <tr>
                      <td>Bakri Eid</td>
                      <td>June 7, 2025</td>
                      <td>Saturday</td>
                    </tr>
                    <tr>
                      <td>Muharram</td>
                      <td>July 6, 2025</td>
                      <td>Sunday</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p><b>How MCX holidays might impact trading in commodity markets</b>
              </p>
              <p>MCX holidays can impact commodity markets by pausing trading, allowing traders to reassess strategies
                and market trends. With no real-time price discovery, volatility may increase upon reopening, especially
                if global events or supply chain disruptions coincide with the holidays. Understanding these breaks
                helps traders manage risks and capitalise on market movements once trading resumes.</p>
            </div>
          </div>

        </section>

        <!-- faq Section Start -->
        <section class="calculator_help_section section-padding-bottom faq-sec p-90">
          <div class="container">
            <h2 class="heading bold help_here text-center">Frequently Asked Questions</h2>
            <div class="smooth-font">
              <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                <div class="panel panel-default">
                  <div class="panel-heading" id="heading1">
                    <h3 class="panel-title">
                      <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section"
                        href="#collapse1">
                        <span class="expand_icon dashicons-plus"></span>
                        <span> When does MCX close in 2025?</span>
                      </span>
                    </h3>
                  </div>
                  <div id="collapse1" class="panel-collapse collapse">
                    <div class="panel-body">
                      <p class="visible">Following is the list of trading holidays for MCX in 2025 (excluding weekends).
                        The exchange may be closed in morning or evening or both the sessions:</p>
                      <ul class="visible">
                        <li><strong>New Year Day</strong>: January 1, 2025 (Wednesday) – Morning Session: Open, Evening
                          Session: Closed</li>
                        <li><strong>Maha Shivratri</strong>: February 26, 2025 (Wednesday) – Morning Session: Closed,
                          Evening Session: Open</li>
                        <li><strong>Holi</strong>: March 14, 2025 (Friday) – Morning Session: Closed, Evening Session:
                          Open</li>
                        <li><strong>Id-ul-Fitr (Ramzan Eid)</strong>: March 31, 2025 (Monday) – Morning Session: Closed,
                          Evening Session: Open</li>
                        <li><strong>Mahavir Jayanti</strong>: April 10, 2025 (Thursday) – Morning Session: Closed,
                          Evening Session: Open</li>
                        <li><strong>Dr. Baba Saheb Ambedkar Jayanti</strong>: April 14, 2025 (Monday) – Morning Session:
                          Closed, Evening Session: Open</li>
                        <li><strong>Good Friday</strong>: April 18, 2025 (Friday) – Morning Session: Closed, Evening
                          Session: Closed</li>
                        <li><strong>Maharashtra Day</strong>: May 1, 2025 (Thursday) – Morning Session: Closed, Evening
                          Session: Open</li>
                        <li><strong>Independence Day</strong>: August 15, 2025 (Friday) – Morning Session: Closed,
                          Evening Session: Closed</li>
                        <li><strong>Ganesh Chaturthi</strong>: August 27, 2025 (Wednesday) – Morning Session: Closed,
                          Evening Session: Open</li>
                        <li><strong>Dussehra/Gandhi Jayanti</strong>: October 2, 2025 (Thursday) – Morning Session:
                          Closed, Evening Session: Closed</li>
                        <li><strong>Diwali-Laxmi Pujan</strong>: October 21, 2025 (Tuesday) – Morning Session: Closed,
                          Evening Session: Closed</li>
                        <li><strong>Diwali-Balipratipada</strong>: October 22, 2025 (Wednesday) – Morning Session:
                          Closed, Evening Session: Open</li>
                        <li><strong>Guru Nanak Jayanti</strong>: November 5, 2025 (Wednesday) – Morning Session: Closed,
                          Evening Session: Open</li>
                        <li><strong>Christmas</strong>: December 25, 2025 (Thursday) – Morning Session: Closed, Evening
                          Session: Closed</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" id="heading2">
                    <h3 class="panel-title">
                      <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section"
                        href="#collapse2">
                        <span class="expand_icon dashicons-plus"></span>
                        <span>How do MCX holidays affect commodity trading?</span>
                      </span>
                    </h3>
                  </div>
                  <div id="collapse2" class="panel-collapse collapse">
                    <div class="panel-body">
                      <p class="visible">MCX holidays create trading breaks, halting market activity and allowing traders time to reassess their strategies. These pauses often lead to increased volatility and price shifts when the market reopens, as delayed reactions to global events or economic news surface. Traders need to stay alert during these periods, as they can influence the next phase of trading once markets resume.

                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" id="heading3">
                    <h3 class="panel-title">
                      <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section"
                        href="#collapse3">
                        <span class="expand_icon dashicons-plus"></span>
                        <span>Is MCX closed on weekends?</span>
                      </span>
                    </h3>
                  </div>
                  <div id="collapse3" class="panel-collapse collapse">
                    <div class="panel-body">
                      <p class="visible">Yes, MCX is closed on weekends, on all Saturdays and Sundays. No trading takes place on these days.

                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" id="heading4">
                    <h3 class="panel-title">
                      <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section"
                        href="#collapse4">
                        <span class="expand_icon dashicons-plus"></span>
                        <span>Can I trade commodities during MCX holidays?</span>
                      </span>
                    </h3>
                  </div>
                  <div id="collapse4" class="panel-collapse collapse">
                    <div class="panel-body">
                      <p class="visible">No, you cannot trade on an MCX holiday. Trading is completely paused, meaning investors cannot place new orders or close existing ones.

                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" id="heading5">
                    <h3 class="panel-title">
                      <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section"
                        href="#collapse5">
                        <span class="expand_icon dashicons-plus"></span>
                        <span>How to stay updated with MCX holidays in 2025?</span>
                      </span>
                    </h3>
                  </div>
                  <div id="collapse5" class="panel-collapse collapse">
                    <div class="panel-body">
                      <p class="visible">To stay updated, check the official MCX website for holidays: (Circular). You can also follow MCX’s social media accounts or use trading apps that notify about market holidays.

                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- End faq Section Start -->
      </div>

      <div class="login-widget smartlist-login">
        <div class="open-account">
          <p class="stock-form-heading"><span>Open a FREE*</span> Demat + Trading account and enjoy</p>
          <p class="form-second-paragraph">Zero commission* on Mutual Funds and IPO</p>
          <p>₹20* per order on Equity, F&amp;O, Commodity and Currency</p>
          <div class="contact-form">
            <form class="contact-input-wrap" method="post" onsubmit="return proceedWithLazyLogin(event, this)">
              <input type="tel" onkeypress="return isNumber(event)" name="phone" id="txtcontact" maxlength="10"
                placeholder="10-Digit mobile number">
              <div class="error-message" id="error-message"></div>
              <button type="submit" class="submit-btn">Start Investing</button>
            </form>
          </div>
          <hr color="#E1E1E1">
          <div class="existing-account">
            By signing up you agree to our <a href="/terms-of-use-and-privacy-policy/">Terms and Conditions</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss" src="@/styles/css/stock-market-holiday.scss">
</style>
<style lang="scss" src="@/styles/css/seo-calculators.scss">
</style>
<style scoped>
  .login-widget.smartlist-login .open-account {
    background: #ffffff;
    border: 1px solid #e1e1e1;
    box-sizing: border-box;
    border-radius: 12px;
    top: 16px;
    width: 100%;
    padding: 24px 24px 16px;
    position: sticky;
  }

  .login-widget.smartlist-login .open-account .header {
    font-size: 20px;
    line-height: 28px;
    letter-spacing: -0.03em;
    color: #5a298b;
  }

  .login-widget.smartlist-login .open-account p {
    font-size: 12px;
    line-height: 16px;
    color: #6a6a6a;
    padding-top: 8px;
  }

  .login-widget.smartlist-login .open-account .contact-form h6 {
    color: #262626;
    font-size: 14px;
    line-height: 20px;
    padding-top: 16px;
    padding-bottom: 8px;
  }

  .smartlist-login .contact-form input {
    width: 100%;
    border-radius: 8px;
    background: #f2f2f2;
    line-height: 24px;
    padding: 8px 8px 8px 36px;
    font-size: 14px !important;
    border: 1px solid transparent;
  }

  .smartlist-login input:focus-visible {
    border-color: #7a26ce !important;
    outline: none;
  }

  .smartlist-login input::-webkit-input-placeholder {
    /* Edge */
    color: #aeaeae;
  }

  .smartlist-login input:-ms-input-placeholder {
    /* Internet Explorer */
    color: #aeaeae;
  }

  .smartlist-login input::placeholder {
    color: #aeaeae;
  }

  .smartlist-login .contact-input-wrap {
    position: relative;
  }

  .smartlist-login .contact-input-wrap::after {
    content: "+91";
    position: absolute;
    color: #6a6a6a;
    top: 9px;
    font-size: 14px;
    line-height: 24px;
    left: 8px;
    font-family: Messina Sans;
  }

  .smartlist-login .error-message span {
    margin-top: 8px;
    display: inline-block;
    font-size: 12px;
    color: #db542a;
  }

  .smartlist-login .error-message span:empty {
    display: none;
  }

  .smartlist-login .submit-btn {
    width: 100%;
    height: 48px;
    background: #5a298b !important;
    border: 1px solid transparent !important;
    border-radius: 24px !important;
    padding: 10px 25px !important;
    color: #ffffff !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 24px !important;
    margin-top: 16px !important;
    transition: all 0.3s ease-in-out 0.1s;
    cursor: pointer;
  }

  .smartlist-login .open-account hr {
    margin: 24px -24px 16px -24px;
    border-color: #e1e1e1;
  }

  .smartlist-login .existing-account {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .smartlist-login .existing-account p {
    padding: 0px !important;
    font-size: 12px;
    line-height: 16px;
    font-family: Messina Sans;
    color: #262626;
  }

  .smartlist-login .login-btn {
    border: 1px solid #d0d0d0 !important;
    border-radius: 100px;
    padding: 8px 16px !important;
    background: white;
    cursor: pointer;
    height: auto !important;
  }

  .smartlist-login .login-btn span {
    font-family: Messina Sans;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    color: #262626;
  }

  .smartlist-login .login-btn:hover span {
    color: #5a298b;
  }

  .smartlist-login .contact-input-wrap:after {
    top: 9px !important;
  }

  @media screen and (max-width: 768px) {
    .login-widget .open-account {
      width: 100%;
      margin-top: 32px;
      position: static;
    }

    .smartlist-login .open-account hr {
      display: none;
    }

    .smartlist-login .existing-account {
      display: none;
    }
  }
</style>